<template>
    <div class="row justify-between full-width no-wrap text-datestamp-item">
      <div class="col">
        <div class="row justify-left no-wrap">
          <q-toggle
            v-model="element.Positive"
            checked-icon="add"
            color="navy"
            label=""
            size="xs"
            unchecked-icon="remove"
          />
          <div class="q-py-xs">c:&nbsp;</div>
          <div class="q-py-xs">{{ getStartDate }}</div>
        </div>
        <div class="row justify-left no-wrap">
          <div class="q-py-xs">&nbsp;&nbsp;{{ $t('by') }}:&nbsp;</div>
          <div class="q-py-xs">{{ getEndDate }}</div>
          <mosta-checkbox
            v-model="element.EndDateIsToday"
            :label="$t('today_calendar')"
            style="margin-left: 6px; margin-top: 4px;"
          />
        </div>
      </div>
      <q-btn
        class="q-mx-none q-mt-none unset-items-center del-btn-datestamp"
        flat
        dense
        :aria-label="$t('delete_filter')"
        icon="close"
        size="sm"
        tabindex="-1"
        color="accent"
        @click="deleteItem"
      >
        <q-tooltip :delay="1000">
          {{ $t('remove') }}
        </q-tooltip>
      </q-btn>
    </div>
  </template>
  
  <script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { SelectionDateStampsFilterSend } from '@/models/interfaces/entity-settings/filters/filters';
  import { date } from 'quasar'
  import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
  
  @Component({
    name: 'DatestampItemElement',
    components: { MostaCheckbox },
  })
  export default class DatestampItemElement extends Vue {
      @Prop({ default: {} as SelectionDateStampsFilterSend })
      element!: SelectionDateStampsFilterSend

      @Emit("itemDeleted") emitDeleteItem(arg: number) { return arg; }
  
      @Prop({ default: false })
      isRoot!: boolean
  
      @Prop({ default: undefined })
      parentId!: number | undefined
      @Prop({ default: undefined })
      parentIdx!: string | undefined
      @Prop({ default: '' })
      parentName!: string
      @Prop({ default: -1 })
      inputIndex!: number
      
      // temporary data
      tempName: string = ''
  
      created() {
          //
      }
  
      get getStartDate(): string {
        const sd = this.element.StartDate || new Date()
        return date.formatDate(sd, 'DD.MM.YYYY')
      }

      get getEndDate(): string {
        const ed = this.element.EndDate || new Date()
        return date.formatDate(ed, 'DD.MM.YYYY')
      }
  
      @Watch('inputItems', { deep: true })
      updateItems() {
          // remember state
          // @ts-ignore
      }

      deleteItem() {
        this.emitDeleteItem(this.inputIndex)
      }
  }
  </script>
  
  <style lang="scss">
  .del-btn-datestamp {
    margin-top: 2px !important;
  }
   
  .text-datestamp-item {
    &--child {
      margin-left: 26px !important;
    }
  }
  </style>